import { FaCog, FaUserShield, FaInfoCircle } from 'react-icons/fa';
import { MdAddToHomeScreen } from 'react-icons/md';

const isMobile = window.innerWidth < 992;

const profileMenuItems = [
  {
    label: 'menu.settings',
    icon: (
      <FaCog
        size={15}
        style={{ marginRight: '0.5rem' }}
      />
    ),
    to: '/profile/settings',
  },
  {
    label: 'menu.twoFA',
    icon: (
      <FaUserShield
        size={15}
        style={{ marginRight: '0.5rem' }}
      />
    ),
    to: '/profile/2fa-settings',
    is2FaProtected: true,
  },
  ...(isMobile
    ? [
        {
          label: 'addToHomescreen.title',
          icon: (
            <MdAddToHomeScreen
              size={17}
              style={{ marginRight: '0.5rem', marginLeft: '-0.1rem' }}
            />
          ),
          to: '/profile/add-to-home-screen',
          addToHomeScreen: true,
          target: '_blank',
        },
      ]
    : []),
];

export default profileMenuItems;
